import DynamicStorage from "./lib/storage/index.js";

const storage = new DynamicStorage()
export default storage